import { Trans, t } from "@lingui/macro";
import { Box, Button, Container } from "@mui/material";
import { Task } from "@carbon/icons-react";
import OnboardingHeader from "@/components/Onboarding/OnboardingHeader";
import PrimaryUseQuestion from "./PrimaryUseQuestion";
import MainSportQuestion from "./MainSportQuestion";
import useOnboardingTrainingPreferences from "./useOnboardingTrainingPreferences";

function TrainingPreferences() {
  const {
    sportOptionListItems,
    primaryUseListItems,
    otherSelected,
    nextDisabled,
    saveAndNavigate,
    otherTextRef,
  } = useOnboardingTrainingPreferences();

  return (
    // Flex column at a fixed height so the questions get their own scroll region and the
    // Next button stays pinned to the bottom. mt="auto" alone did nothing here: the
    // Container was not a flex parent, so the button sat in flow below the fold.
    <Container
      maxWidth="sm"
      disableGutters
      sx={{ height: "100%", display: "flex", flexDirection: "column" }}
    >
      <Box display="flex" flexDirection="column" gap={4} flex={1} minHeight={0} overflow="auto">
        <OnboardingHeader
          Icon={Task}
          title={t`Training preferences`}
          subtitle={t`Tell us a bit about your preferences to help us tailor workout recommendations just for you.`}
        />
        <MainSportQuestion sportOptionListItems={sportOptionListItems} />
        <PrimaryUseQuestion
          primaryUseListItems={primaryUseListItems}
          otherSelected={otherSelected}
          otherTextRef={otherTextRef}
        />
      </Box>
      <Box px={3} pt={2} pb="var(--wf-bottom-safe-area, 0px)" width="100%" maxWidth="sm">
        <Button
          variant="contained"
          size="large"
          fullWidth
          onClick={saveAndNavigate}
          disabled={nextDisabled}
        >
          <Trans>Next</Trans>
        </Button>
      </Box>
    </Container>
  );
}

export default TrainingPreferences;
